// defs
import { IRatingSummary } from 'shared/layouts/DetailsPage/types';

interface IReviewSplitup {
  aggregated: string;
  total_count: number;
  [key: number]: IRatingSummary;
}

// return a descending order array with elements of type IRatingSummary from reviewSplitup
export const createReverseArray = (reviewSplitup: IReviewSplitup, maxRatingCount: number) => {
  let tempRatingSummary: IRatingSummary[] = [];

  // inserting rating summary data for each rating(eg rating 1, 2, 3) in tempRatingSummary
  for (const a in reviewSplitup) {
    if (
      typeof reviewSplitup[a] === 'object' &&
      reviewSplitup[a] !== null &&
      reviewSplitup[a].star !== undefined
    ) {
      tempRatingSummary[reviewSplitup[a].star - 1] = { ...reviewSplitup[a] };
    }
  }

  // inserting default data for those rating in tempRatingSummary which does not have any data
  for (let i = 0; i < maxRatingCount; i++) {
    if (tempRatingSummary[i] === undefined) {
      const ratingObject = {
        count: '0',
        star: i + 1,
        per: 0,
      };

      tempRatingSummary[i] = ratingObject;
    }
  }

  return tempRatingSummary.reverse();
};
